import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as actions from '../action';

function BusinessPermitRenewPermit({
  data,
  mode,
  formData,
  handleChangeInput,
}) {
  return (
    <table>
      <thead>
        <tr>
          <td>Line of Business</td>
          <td>Nature of Business</td>
          <td>Gross Essential</td>
          <td>Gross Non-essential</td>
          <td>Mayor`s Fee</td>
        </tr>
      </thead>
      <tbody>
        {_.isEmpty(data) ? (
          <tr className="w-100">
            <td colSpan="5" className="text-center border-top p-4 text-muted">
              This Section is Empty
            </td>
          </tr>
        ) : (
          <React.Fragment>
            {mode.businessActivity === 0 ? (
              data.map(item => (
                <tr key={item.id}>
                  <td className="border-top">{_.get(item, 'line_business')}</td>
                  <td className="border-top">{_.get(item, '_nature_business_name')}</td>
                  <td className="border-top">{_.get(item, 'essential')}</td>
                  <td className="border-top">{_.get(item, 'non_essential')}</td>
                  <td className="border-top">{_.get(item, 'capitalization')}</td>
                </tr>
              ))
            ) : (
              data.map(item => (
                <tr key={item.id}>
                  <td className="border-top">{_.get(item, 'line_business')}</td>
                  <td className="border-top p-2">
                    <input
                      className="form-control"
                      type="text"
                      id={item._nature_business_name}
                      onChange={handleChangeInput(item, '_nature_business_name')}
                      value={
                        _.get(
                          _.find(formData, x => x.id === item.id) || {},
                          '_nature_business_name',
                        ) || ''
                      }
                    />
                  </td>
                  <td className="border-top p-2">
                    <input
                      className="form-control"
                      type="number"
                      id={item.essential}
                      onChange={handleChangeInput(item, 'essential')}
                      value={
                        _.get(
                          _.find(formData, x => x.id === item.id) || {},
                          'essential',
                        ) || ''
                      }
                    />
                  </td>
                  <td className="border-top p-2">
                    <input
                      className="form-control"
                      type="number"
                      id={item.non_essential}
                      onChange={handleChangeInput(item, 'non_essential')}
                      value={
                        _.get(
                          _.find(formData, x => x.id === item.id) || {},
                          'non_essential',
                        ) || ''
                      }
                    />
                  </td>
                  <td className="border-top p-2">
                    <input
                      className="form-control"
                      type="number"
                      id={item.capitalization}
                      onChange={handleChangeInput(item, 'capitalization')}
                      value={
                        _.get(
                          _.find(formData, x => x.id === item.id) || {},
                          'capitalization',
                        ) || ''
                      }
                    />
                  </td>
                </tr>
              ))
            )}
          </React.Fragment>
        )}
      </tbody>
    </table>
  );
}

BusinessPermitRenewPermit.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  mode: PropTypes.instanceOf(Object).isRequired,
  handleChangeInput: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(BusinessPermitRenewPermit);
